"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postSupplierType = void 0;
/**
 * Create a new supplier-type
 */
var postSupplierType = function (instance) {
    return function (body, config) {
        return instance.post("/suppliers/types", body, config);
    };
};
exports.postSupplierType = postSupplierType;
